import { Row, Col, Container, Button } from 'react-bootstrap';

import parallaxImg from '../assets/images/performance-marketting.jpg';
import userImage from '../assets/images/avator-man.jpg';
import avatorWomen from '../assets/images/avator-women.jpg';
import avatorWomen2 from '../assets/images/avator-women-2.jpg';
import { useNavigate } from 'react-router-dom';


import rocketIcon from '../assets/images/rocket-icon.svg';

import sun from '../assets/images/sun.svg';

import atom from '../assets/images/atom.svg';
import rover from '../assets/images/rover.svg';
import checkicon from '../assets/images/check-icon.svg';
import missionRocket from '../assets/images/mission-rocket.svg';

const AboutUs = () => {

    const navigate = useNavigate();
    return (
        <div className='mt-5 pt-5'>

            <Container>
                <section className='mt-5  position-relative'>
                    <img src={rocketIcon} alt='floating-icons' className='floating-icons left top' style={{ left: "-100px", top: "-50px" }} />
                    <img src={sun} alt='floating-icons' className='floating-icons right bottom rotate' />

                    <Row>
                        {/* <Col md={2}>
                            <div className="title-pill">About Adrocket</div>
                        </Col> */}
                        <Col md={12} className='px-4'>
                            <p className='text-white'><span className='text-theme'>AD ROCKET</span> is a Chennai-based digital marketing company built with one mission</p>
                            <h1 className='about-title outline-text'> To make brands grow with creativity that converts and strategies backed by real data.</h1>

                            <Row className='text-white mb-5'>
                                <Col md={12} className="mt-4">
                                    <div className='d-flex align-items-center'>
                                        <div>
                                            <div className='ckeck-icon-wrapper d-inline-flex align-items-center justify-content-center mt-2'>
                                                <img src={checkicon} alt="check-icon" className='check-icon' />
                                            </div>
                                        </div>
                                        <p className='ms-2 mb-0 mt-2'>We’re young, hungry, and slightly obsessed with performance.</p>
                                    </div>
                                </Col>
                                <Col md={12} className="mt-4">
                                    <div className='d-flex align-items-center'>
                                         <div>
                                            <div className='ckeck-icon-wrapper d-inline-flex align-items-center justify-content-center mt-2'>
                                                <img src={checkicon} alt="check-icon" className='check-icon' />
                                            </div>
                                        </div>
                                        <p className='ms-2 mb-0 mt-2'>We don’t believe in “posting for the sake of posting.”</p>
                                    </div>
                                </Col>
                                <Col md={12} className="mt-4">
                                    <div className='d-flex align-items-center'>
                                         <div>
                                            <div className='ckeck-icon-wrapper d-inline-flex align-items-center justify-content-center mt-2'>
                                                <img src={checkicon} alt="check-icon" className='check-icon' />
                                            </div>
                                        </div>
                                        <p className='ms-2 mb-0 mt-2'>We believe in momentum — the kind you can measure.</p>
                                    </div>
                                </Col>
                            </Row>

                            <div className='text-white'>
                                <h1 className='about-title outline-text mb-4'>Our Story</h1>
                                <p className='mb-2'>Advertising is where <span className='outline-theme-text'>AdRocket</span> found its edge.</p>

                                <p className='mb-2'>Performance marketing is our core strength, and one we’ve mastered with proven ROI-driven campaigns across India, Dubai, Qatar, and the USA.
                                    But here’s what our clients kept telling us:
                                    “Ads work… but we need everything to work together.”
                                </p>

                                <p>So we listened. Great ads need strong brands behind them. So we expanded thoughtfully, strategically, and intentionally into a 360° digital marketing agency, offering everything a brand needs under one roof.</p>

                                <h3 className='my-4'>Today, <span className='outline-theme-text'>AdRocket</span> delivers:</h3>
                                <Row className='text-white'>
                                    <Col md={4}>
                                        <div className='d-flex align-items-center mb-2'>
                                            <div className='ckeck-icon-wrapper d-inline-flex align-items-center justify-content-center mt-2'>
                                                <img src={checkicon} alt="check-icon" className='check-icon' />
                                            </div>
                                            <p className='ms-2 mb-0 mt-2'>Performance & paid advertising</p>
                                        </div>

                                        <div className='d-flex align-items-center mb-2'>
                                            <div className='ckeck-icon-wrapper d-inline-flex align-items-center justify-content-center mt-2'>
                                                <img src={checkicon} alt="check-icon" className='check-icon' />
                                            </div>
                                            <p className='ms-2 mb-0 mt-2'>Social media management</p>
                                        </div>
                                        <div className='d-flex align-items-center mb-2'>
                                            <div className='ckeck-icon-wrapper d-inline-flex align-items-center justify-content-center mt-2'>
                                                <img src={checkicon} alt="check-icon" className='check-icon' />
                                            </div>
                                            <p className='ms-2 mb-0 mt-2'>Branding & logo design</p>
                                        </div>
                                        <div className='d-flex align-items-center mb-2'>
                                            <div className='ckeck-icon-wrapper d-inline-flex align-items-center justify-content-center mt-2'>
                                                <img src={checkicon} alt="check-icon" className='check-icon' />
                                            </div>
                                            <p className='ms-2 mb-0 mt-2'>Website development</p>
                                        </div>
                                    </Col>
                                    <Col md={4} className='mb-2'>

                                        <div className='d-flex align-items-center mb-2'>
                                            <div className='ckeck-icon-wrapper d-inline-flex align-items-center justify-content-center mt-2'>
                                                <img src={checkicon} alt="check-icon" className='check-icon' />
                                            </div>
                                            <p className='ms-2 mb-0 mt-2'>Website development</p>
                                        </div>
                                        <div className='d-flex align-items-center mb-2'>
                                            <div className='ckeck-icon-wrapper d-inline-flex align-items-center justify-content-center mt-2'>
                                                <img src={checkicon} alt="check-icon" className='check-icon' />
                                            </div>
                                            <p className='ms-2 mb-0 mt-2'>Video production</p>
                                        </div>
                                        <div className='d-flex align-items-center mb-2'>
                                            <div className='ckeck-icon-wrapper d-inline-flex align-items-center justify-content-center mt-2'>
                                                <img src={checkicon} alt="check-icon" className='check-icon' />
                                            </div>
                                            <p className='ms-2 mb-0 mt-2'>Personal branding</p>
                                        </div>
                                        <div className='d-flex align-items-center mb-2'>
                                            <div className='ckeck-icon-wrapper d-inline-flex align-items-center justify-content-center mt-2'>
                                                <img src={checkicon} alt="check-icon" className='check-icon' />
                                            </div>
                                            <p className='ms-2 mb-0 mt-2'>Content & SEO services</p>
                                        </div>
                                    </Col>
                                </Row>

                                <p className='mb-5 mt-3'>All seamlessly connected, so nothing feels fragmented, and every effort drives growth.</p>
                            </div>


                        </Col>
                    </Row>
                </section>

                <section className='my-5'>
                    <div className="parallax-about" style={{
                        backgroundImage: `url(${parallaxImg})`
                    }}
                    >
                    </div>
                </section>

                <section className='text-white mb-5'>


                    <Row>
                        <Col lg={3} className='d-flex align-items-center justify-content-center'>
                            <img src={missionRocket} alt='mission-rocket' className='mission-rocket' />
                        </Col>
                        <Col lg={9}>
                            <h2 className='mt-4 mb-2'>Who we are</h2>
                            <p className='mb-1'>Strong brands often underperform because their message doesn’t reach the audiences most likely to convert. AdRocket was founded on one clear purpose: <span className='outline-theme-text d-block'>To connect the right brands with the right audience, at the right time.</span></p>


                            <h2 className='mt-4 mb-2'>Our <span className='outline-theme-text'>Mission</span> became simple.</h2>
                            <p className='mb-1'>Give the right brands a voice, amplify their presence, and elevate them to where they truly belong.</p>
                            <p>So our clients can do what they do best: Expand their services, deliver results, and serve their customers, while we take care of the marketing, strategy, and growth.</p>
                        </Col>
                    </Row>
                </section>

                <section className='mb-5 py-5 position-relative border-top-custom'>
                    <img src={atom} alt='floating-icons' className='floating-icons left top rotate' style={{ left: "-100px", top: "-50px" }} />
                    <img src={rover} alt='floating-icons' className='floating-icons right bottom' />

                    <Row>
                        {/* <Col md={2}>
                            <div className="title-pill">Our Philosophy</div>
                        </Col> */}
                        <Col md={12}>
                            <div className="text-center">
                                <span className='hero-sub-title'>Our Philosophy</span>
                                <h1 className='hero-title mb-5 pb-5 outline-text'>We Blend All Three Together.</h1>
                            </div>
                            <div className='d-flex align-items-center justify-content-center philosophy-list flex-column flex-md-row'>
                                <div className='circle-1'>
                                    <i className="fa-solid fa-user-astronaut"></i>
                                    Creativity <br /> <span className='hover-text'>wins attention</span></div>
                                <div className='circle-2'><i className="fa-solid fa-meteor"></i>Strategy <br /> <span className='hover-text'>wins conversions.</span></div>
                                <div className='circle-3'><i className="fa-solid fa-chart-simple"></i>Performance <br /> <span className='hover-text'>wins business</span></div>
                            </div>
                            {/* <h1 className='outline-theme-text mt-5 text-center'></h1> */}
                        </Col>
                    </Row>
                </section>

                <section className='border-top-custom py-5'>
                    {/* <Row className='px-3'>
                        <Col lg={3} xl={2}>
                            <div className="title-pill mb-4">The Crew</div>
                        </Col>
                        <Col lg={6} xl={8}>
                            <h1 className='crew-title text-white mb-4'>A multi-disciplinary team of designers, managers, writers, analysts, and strategists…
                                <br className='d-none d-md-block' /> <strong>All aligned on one goal  to scale your brand without wasting a rupee.</strong>
                            </h1>
                        </Col>
                        <Col lg={3} xl={2}>
                            <Button variant="theme" className='btn-rounded link mb-4 ms-auto'>
                                <span className=" fs-14 fw-500">Join with us</span>
                                <span className="arrow-icon">
                                    <i className="fa-solid fa-arrow-right icon"></i>
                                    <i className="fa-solid fa-arrow-right icon"></i>
                                </span>
                            </Button>
                        </Col>
                    </Row> */}

                    <div className="text-center">
                        <span className='hero-sub-title'>We are AdRocket</span>
                        <h1 className='hero-title  outline-text'>The People Behind AdRocket</h1>
                    </div>

                    <Row>
                        <Col className='mt-3' md={4}>
                            <div className="team-member-box my-md-5 mb-4">
                                <div className="team-member-image" style={{ backgroundImage: `url(${avatorWomen})` }}>

                                    <div className="team-member-social">
                                        <Button variant="outline-light social" className='mb-1 me-2'><i className="fa-brands fa-facebook-f"></i></Button>
                                        <Button variant="outline-light social" className='mb-1 me-2'><i className="fa-brands fa-x-twitter"></i></Button>
                                        <Button variant="outline-light social" className='mb-1 me-2'><i className="fa-brands fa-instagram"></i></Button>
                                        <Button variant="outline-light social" className='mb-1 me-2'><i className="fa-brands fa-linkedin-in"></i></Button>
                                    </div>
                                </div>
                                <div className="team-member-info mt-3 px-2">
                                    <h4 className='mb-2'>Simin</h4>
                                    <span>the heart of AdRocket, is your go-to person for everything digital. With in-depth experience in project and people management, she understands exactly what your brand needs and how to get it done, end to end.</span>
                                </div>
                            </div>
                        </Col>
                        <Col md={4}>
                            <div className="team-member-box my-md-5 mb-4">
                                <div className="team-member-image" style={{ backgroundImage: `url(${userImage})` }}>

                                    <div className="team-member-social">
                                        <Button variant="outline-light social" className='mb-1 me-2'><i className="fa-brands fa-facebook-f"></i></Button>
                                        <Button variant="outline-light social" className='mb-1 me-2'><i className="fa-brands fa-x-twitter"></i></Button>
                                        <Button variant="outline-light social" className='mb-1 me-2'><i className="fa-brands fa-instagram"></i></Button>
                                        <Button variant="outline-light social" className='mb-1 me-2'><i className="fa-brands fa-linkedin-in"></i></Button>
                                    </div>
                                </div>
                                <div className="team-member-info mt-3 px-2">
                                    <h4 className='mb-2'>Samadh</h4>
                                    <span> our performance marketing specialist, is obsessed with numbers and for good reason. With global experience across Meta and Google Ads, multiple industries, and award-winning campaigns, he turns ad spend into measurable growth.</span>
                                </div>
                            </div>
                        </Col>
                        <Col className='mt-3' md={4}>
                            <div className="team-member-box my-md-5 mb-4">
                                <div className="team-member-image" style={{ backgroundImage: `url(${avatorWomen2})` }}>

                                    <div className="team-member-social">
                                        <Button variant="outline-light social" className='mb-1 me-2'><i className="fa-brands fa-facebook-f"></i></Button>
                                        <Button variant="outline-light social" className='mb-1 me-2'><i className="fa-brands fa-x-twitter"></i></Button>
                                        <Button variant="outline-light social" className='mb-1 me-2'><i className="fa-brands fa-instagram"></i></Button>
                                        <Button variant="outline-light social" className='mb-1 me-2'><i className="fa-brands fa-linkedin-in"></i></Button>
                                    </div>
                                </div>
                                <div className="team-member-info mt-3 px-2">
                                    <h4 className='mb-2'>Shaheena</h4>
                                    <span>our lead generation and branding expert, brings creativity with purpose. Her eye for detail and content ensures every post, design, and campaign feels fresh, unique, and unmistakably on-brand.</span>
                                </div>
                            </div>
                        </Col>

                    </Row>

                    <div className='text-center'>
                        <p className='crew-title text-white mb-4'>If you’re tired of average marketing, scattered efforts, and unclear results,<br />
                            AdRocket is here to make your growth feel lighter, faster, and smarter.
                        </p>

                        <Button variant="theme" className='btn-rounded mb-4 mx-auto' onClick={() => navigate('/careers')}>
                            <span className=" fs-14 fw-500">Join with us</span>
                            <span className="arrow-icon">
                                <i className="fa-solid fa-arrow-right icon"></i>
                                <i className="fa-solid fa-arrow-right icon"></i>
                            </span>
                        </Button>

                    </div>


                </section>

            </Container>
        </div>
    )
};

export default AboutUs;